import { createI18n } from 'vue-i18n';
import { getStorageLocale, getUserFromStorage } from '@/helpers/auth';
import { User } from '@/types/User';
import { EN_LOCAL, FR_LOCAL } from '@/helpers/locale';
import fr from './fr/index';
import en from './en/index';

let defaultLocale;
if (navigator.language !== EN_LOCAL) {
    defaultLocale = FR_LOCAL;
} else {
    defaultLocale = navigator.language || FR_LOCAL;
}

const i18n = createI18n({
    legacy: true, // Enable legacy mode for Vue 2 compatibility
    locale: defaultLocale,
    silentTranslationWarn: true,
    silentFallbackWarn: true,
    fallbackLocale: FR_LOCAL,
    messages: {
        en,
        fr,
    },
});

const user: null | User = getUserFromStorage();

if (getStorageLocale()) {
    i18n.global.locale = getStorageLocale() as any;
} else if (user) {
    if (user.locale) {
        i18n.global.locale = user.locale as any;
    } else {
        i18n.global.locale = defaultLocale as any;
    }
} else {
    i18n.global.locale = defaultLocale as any;
}

export default i18n;
